<template>
    <table class="contacts-list dt-table">
        <thead>
            <tr>
                <th>{{ l('CUSTOMER_DETAILS.NAME') }}</th>
                <th>{{ l('CUSTOMER_DETAILS.REFERENCE') }}</th>
                <th class="dt-table__cell--last">
                    {{ l('CUSTOMER_DETAILS.PHOTO') }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="contact in contacts"
                :key="contact.ID">
                <td>
                    <ContactName :contact="contact" />
                    <p v-if="contact.email"
                       class="desktop-only break-wrap mt-05 mb-0 non-bold">
                        <i class="fa-solid fa-fw fa-envelope"></i>
                        {{ contact.email }}
                    </p>
                    <p v-if="contact.tel"
                       class="desktop-only break-wrap mt-05 mb-0 non-bold">
                        <i class="fa-solid fa-fw fa-phone"></i>
                        {{ contact.tel }}
                    </p>
                </td>
                <td>
                    <i class="fa-solid fa-fw fa-barcode mobile-only"></i>
                    {{ contact.ref }}
                </td>
                <td class="break-wrap mobile-only"
                    :class="{'dt-table__cell--empty': !contact.email}">
                    <i class="fa-regular fa-fw fa-envelope"></i>
                    {{ contact.email }}
                </td>
                <td class="break-wrap mobile-only"
                    :class="{'dt-table__cell--empty': !contact.tel}">
                    <i class="fa-regular fa-fw fa-phone"></i>
                    {{ contact.tel }}
                </td>
                <td class="dt-table__cell--last contacts-list__photo-cell">
                    <ContactPhoto :contact="contact"
                                  :width="200"
                                  :height="200"></ContactPhoto>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import ContactName from '@/epos/vue/components/Customers/ContactName';
import ContactPhoto from '@/epos/vue/components/Customers/ContactPhoto';

export default {
    components: {
        ContactName,
        ContactPhoto,
    },

    props: {
        contacts: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="less">
@import (less, reference) "../../../../less/variables.less";

@media (max-width: @mobile-max) {
    .contacts-list {
        &__photo-cell {
            font-size: 0; // Prevent gaps caused by whitespace.
            margin: 0 -10px !important; // Remove left and right padding to bring it to the edge of the card.
        }

        .contact-photo {
            width: 100%;
            height: 252px; // 4:3 on a CT40
        }
    }
}

@media (min-width: @non-mobile-min) {
    .contacts-list {
        &__photo-cell {
            text-align: right;
        }

        .contact-photo {
            width: 140px;
            height: 105px; // 4:3 aspect ratio
        }
    }
}

@media (min-width: @screen-lg-min) {
    .contacts-list {
        .contact-photo {
            width: 200px;
            height: 150px; // 4:3 aspect ratio
        }
    }
}
</style>
